import { FC, useMemo } from 'react'
import { useState } from 'react'
import { useContext } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { PaginationLoader } from '../components/Loader'
import { Button } from '../components/UI/Buttons'
import { EventContext } from '../ctx/event'
import { TRow } from '../types/api'
import { Margin } from './Margin'

export const Pagination: FC<{
    row: TRow<any>
    length: number
}> = ({ row, children, length }) => {
    const { onPaginationPage } = useContext(EventContext)
    const [page, setPage] = useState(1)
    const [btn, setBtn] = useState(row.totalRows > row.pageSize)
    const [active, setActive] = useState(false)
    const hasMore = useMemo(
        () => row.page < row.totalRows / row.pageSize,
        [row]
    )
    const showBtnStart = useMemo(() => btn && hasMore, [btn, hasMore])

    function nextPage() {
        setPage(page + 1)
        if (onPaginationPage) onPaginationPage(page + 1)
    }
    function start() {
        setActive(true)
        setBtn(false)
        window.scrollTo({ top: window.scrollY - 100, behavior: 'smooth' })
    }

    return active ? (
        <InfiniteScroll
            next={nextPage}
            loader={<PaginationLoader></PaginationLoader>}
            hasMore={hasMore}
            dataLength={length}
            style={{ overflow: 'initial' }}
        >
            {children}
        </InfiniteScroll>
    ) : (
        <>
            {children}
            {showBtnStart ? (
                <Margin margin={{ top: 20 }}>
                    <div className="pagination-btn">
                        <Button onClick={start} size="large" rounded shadow>
                            Load More
                        </Button>
                    </div>
                </Margin>
            ) : null}
        </>
    )
}
